// @ts-nocheck 
import { Instance, types } from 'mobx-state-tree';
import { AddressModelBase } from './AddressModel.base';

/* The TypeScript type of an instance of AddressModel */
export interface AddressModelType extends Instance<typeof AddressModel.Type> {}

/* A graphql query fragment builders for AddressModel */
export {
  selectFromAddress,
  addressModelPrimitives,
  AddressModelSelector,
} from './AddressModel.base';

/**
 * AddressModel
 *
 * Address
 */
export const AddressModel = AddressModelBase
.props({
  phone: types.union(types.undefined, types.null, types.string),
})
.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self));
  },
})).views((self) => ({
  get address() {
    return [self.street, self.suburb, self.state, self.postcode]
      .filter(Boolean)
      .join(', ');
  },
  get fullAddress() {
    return [self.name, this.address].join('\n');
  },
}));
